import { createTheme } from '@mui/material/styles';
import { getCurrentLanguageFonts } from './fontConfig';
import lightTheme from 'assets/theme';
import darkTheme from 'assets/theme-dark';

export const createLanguageAwareTheme = (isDarkMode = false) => {
  const currentFonts = getCurrentLanguageFonts();
  const baseTheme = isDarkMode ? darkTheme : lightTheme;

  return createTheme({
    ...baseTheme,
    typography: {
      ...baseTheme.typography,
      fontFamily: currentFonts.primary,
      h1: { ...baseTheme.typography.h1, fontFamily: currentFonts.display },
      h2: { ...baseTheme.typography.h2, fontFamily: currentFonts.display },
      h3: { ...baseTheme.typography.h3, fontFamily: currentFonts.bold },
      h4: { ...baseTheme.typography.h4, fontFamily: currentFonts.bold },
      h5: { ...baseTheme.typography.h5, fontFamily: currentFonts.bold },
      h6: { ...baseTheme.typography.h6, fontFamily: currentFonts.bold },
      button: {
        ...baseTheme.typography.button,
        fontFamily: currentFonts.secondary,
      },
      body1: {
        ...baseTheme.typography.body1,
        fontFamily: currentFonts.primary,
      },
      body2: {
        ...baseTheme.typography.body2,
        fontFamily: currentFonts.primary,
      },
      subtitle1: {
        ...baseTheme.typography.subtitle1,
        fontFamily: currentFonts.primary,
      },
      subtitle2: {
        ...baseTheme.typography.subtitle2,
        fontFamily: currentFonts.primary,
      },
      caption: {
        ...baseTheme.typography.caption,
        fontFamily: currentFonts.primary,
      },
      overline: {
        ...baseTheme.typography.overline,
        fontFamily: currentFonts.primary,
      },
    },
    components: {
      ...baseTheme.components,
      MuiCssBaseline: {
        styleOverrides: {
          ...baseTheme.components?.MuiCssBaseline?.styleOverrides,
          body: {
            fontFamily: `${currentFonts.primary} !important`,
          },
          '*': {
            fontFamily: `${currentFonts.primary} !important`,
          },
        },
      },
    },
  });
};
